import { Stage } from '@eventbrite/webapp-constants';
import { EBDomains, EBEnvs } from './types';

export const DOMAINS_ENVS = {
    [EBDomains.EVENTBRITE]: EBEnvs.PROD,
    [EBDomains.EVBSTAGE]: EBEnvs.STAGE,
    [EBDomains.EVBQA]: EBEnvs.QA,
    [EBDomains.EVBDEV]: EBEnvs.DEV,
};

export const DOMAINS_STAGES = {
    [EBDomains.EVENTBRITE]: Stage.PROD,
    [EBDomains.EVBSTAGE]: Stage.PREPROD,
    [EBDomains.EVBQA]: Stage.TEST,
    [EBDomains.EVBDEV]: Stage.DEV,
    localhost: Stage.LOCAL,
};

export const DOMAINS: EBDomains[] = [
    EBDomains.EVENTBRITE,
    EBDomains.EVBSTAGE,
    EBDomains.EVBQA,
    EBDomains.EVBDEV,
];
